import React from 'react';
import classes from './SliderToggle.module.css';

const sliderToggle = (props) => {
  const swithClasses = [classes.Switch];
  if (props.checked) swithClasses.push(classes.Checked);
  return (
    <label className={swithClasses.join(' ')}>
      <input onChange={props.toggle} checked={props.checked} type="checkbox" />
      <span className={classes.RoundSlider} />
    </label>
  );
};

export default sliderToggle;
